import * as React from "react"
import * as ProgressPrimitive from "@radix-ui/react-progress"

import { cn } from "@/lib/utils.ts"
import { themeAtom } from "@/features/app-layout/atoms/theme-atoms.ts"
import { useAtomValue } from "jotai"

const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root>
>(({ className, value, ...props }, ref) => {

  const themeClasses = useAtomValue(themeAtom)

  return (
    <ProgressPrimitive.Root
      ref={ref}
      className={cn(
        "relative h-2 w-full overflow-hidden rounded-full bg-white dark:bg-neutral-50/20",
        className
      )}
      {...props}
    >
      <ProgressPrimitive.Indicator
        className="h-full w-full flex-1 bg-gradient-to-r from-theme-secondary via-theme-alternate to-theme-primary transition-all rounded-full"
        style={{
          transform: `translateX(-${100 - (value || 0)}%)`,
          backgroundImage: `linear-gradient(to right, ${themeClasses.secondary}, ${themeClasses.alternate}, ${themeClasses.primary})`
        }}
      />
    </ProgressPrimitive.Root>
  )
})
Progress.displayName = ProgressPrimitive.Root.displayName

export { Progress }
